import { render, staticRenderFns } from "./mock-shift-landing.vue?vue&type=template&id=73844344&scoped=true&"
import script from "./mock-shift-landing.vue?vue&type=script&lang=js&"
export * from "./mock-shift-landing.vue?vue&type=script&lang=js&"
import style0 from "./mock-shift-landing.vue?vue&type=style&index=0&id=73844344&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73844344",
  null
  
)

export default component.exports